module.exports = __webpack_public_path__ + "static/img/55-1.efb0847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/55-1.jpg
// module id = F7L3
// module chunks = 0